import { SET_ANSWERS } from '../types';
export const setAnswers = _ref => {
  let {
    currentAnswers,
    exerciseId
  } = _ref;
  return {
    currentAnswers,
    exerciseId,
    type: SET_ANSWERS
  };
};